import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace QmsFindingTypesFields {
  export enum CommonField {
    FindingTypesSequentialNumberingFormat = 'FindingTypes.SequentialNumberingFormat',
  }
}

class CommonConfig extends SettingsSubModule {
  @SettingsSubModule.value(QmsFindingTypesFields.CommonField.FindingTypesSequentialNumberingFormat, '')
  sequentialNumberingFormat: SettingValue<string>;
}

export class QmsFindingTypesModule extends SettingsModule {
  @SettingsModule.value(CommonConfig) common: CommonConfig;
}
